<template>
  <div class="animated fadeIn">
    <div v-if="ModalHtmlContent.zoom">
      <v-carousel
        cycle
        height="400"
        hide-delimiter-background
        :show-arrows="false"
      >
        <v-carousel-item
          v-for="(item,i) in items"
          :key="i"
          :src="getUrlContentImage(ModalHtmlContent.name, i+1)"
        >
        </v-carousel-item>
      </v-carousel>
    </div>
    <div v-html="ModalHtmlContent.html"></div>
  </div>
</template>

<script>

import { EventBus } from '@/js/EventBus.js'

export default {
  name: 'newHObject',
  components: {

  },
  props: ['ModalHtmlContent'],
  data () {
    return {
      items: [],
      urlBackImages: `${ENV.server_back}/api/content/image/`
    }
  },
  mounted: function () {

  },
  watch: {
    'ModalHtmlContent.numImages': function () {
      this.items= []
      for(let i = 0; i < this.ModalHtmlContent.numImages; i++) {
        this.items.push(i)
      }
    }
  },
  methods: {
    getUrlContentImage (filename, index) {
      // console.log('Contando imagenes.....' + index)
      return `${this.urlBackImages}${this.getSlug(filename)}-${index}`
    },
    getSlug (str) {
      if(str !== undefined) {
        str = str.toLowerCase()
        return str.replace(/ /g, '-')
      }
      return ''
    }
  }
}
</script>

<style scope>

.modal-xl {
  max-width: 90% !important;
}

.modal-xl .card-footer {
    padding: 0.2rem 0.25rem 0.2rem 1.25rem;
}

.cardhObject {
  width: 250px;
  float: left;
  margin: 1%;
}

.pull-right {
    float: right !important;
}

.theme--dark.v-btn.v-btn--icon {
    background-color: rgba(0, 0, 0, 0.4);
}

</style>



// WEBPACK FOOTER //
// src/views/Content/HtmlContent.vue